import React, { Fragment } from "react";
import { Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: 391,
    display: 'flex',
    alignItems: 'center',
    // background: `linear-gradient(rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35)), url(${process.env.PUBLIC_URL}/images/home.png))`,
    background: `linear-gradient(270deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%), url(${process.env.PUBLIC_URL}/images/secondSection.png)`,
    // backgroundImage: `url(${process.env.PUBLIC_URL}/images/home.png)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  textContent: {
    fontFamily: 'poppins',
    fontSize: 32,
    textAlign: 'center',
    paddingLeft: '10%',
    paddingRight: '10%',
    [theme.breakpoints.down('sm')]:{
      fontSize: 20,
      paddingLeft: '2%',
      paddingRight: '2%',
    }
  }
}));

export default function SecondSection() {
  const classes = useStyles()
  return (
    <Fragment>            
      <div className={classes.wrapper}>
        <Typography variant="body1" className={classes.textContent}>
          Future-proof content management with solutions and tools based on deep industry expertise. 
          Create seamless operational workflows from complex processes with one-click automation. Gain control, mitigate risks, 
          and recognize maximum revenue potential by making your content available on every platform and language. 
        </Typography>
      </div>
    </Fragment>
  );
}
